import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import TimesheetService from '../../components/timesheet/TimesheetService';

const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle'

};

export const fetchTask = createAsyncThunk('task', async () => {
    const response = await TimesheetService.getTasks(true);
    return response;
});

export const TaskSlice = createSlice({
    name: 'task',
    initialState,
    reducers: {
        addTaskConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToTaskConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTask.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTask.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })

    }
});


export const selectTask = (state) => state.task.data;
